import { Link } from 'react-router-dom';
import styled from 'styled-components';

export default styled(Link)`
    text-decoration: none;
    color: #00a3e0;
`;
